import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { artBoardActions } from '@store/reducers/artboard'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

/**
 * Режим артборда — состояние конкретного проекта, а стор один на всё
 * приложение, и перехода между проектами он не переживал бы: включил SEO-режим
 * в проекте A, ушёл в дашборд, открыл B — B открывался бы сразу в SEO-режиме.
 * То же с settings и estimate.
 *
 * Раньше это чинилось побочно: сокет закрывается и открывается заново на
 * каждую смену проекта (useProjectSocketsInit), а его коннект дёргал
 * setReadonly(false), который сбрасывал режим каким бы он ни был. Сброс мы
 * сузили — иначе режим, выставленный до загрузки проекта (возврат с консента
 * Google, дип-линк), затирался бы, — так что теперь это делается явно.
 *
 * Именно на выходе, а не на входе: сбрасывать при открытии значит опять
 * гоняться с тем, кто выставляет режим до загрузки.
 */
export const useProjectModeReset = () => {
  const dispatch = useDispatch()
  const projectId = useSelector(migrationProjectSelector.getProjectId)

  useEffect(() => {
    if (!projectId) {
      return
    }

    return () => {
      dispatch(artBoardActions.changeMode('edit'))
    }
  }, [dispatch, projectId])
}
